import React from 'react'

import { V2AcceptanceOfferDetailsContainer } from '../../../onboarding/v2-acceptance-offer-details/V2AcceptanceOfferDetailsContainer'

export const RelinkAcceptanceOfferDetailsContainer = () => {
  return <V2AcceptanceOfferDetailsContainer isRelink showSettings />
}
